export default __webpack_public_path__ + "static/media/PlayH9.ffb8955f.png";